import { render, staticRenderFns } from "./CardTarjaEnqueteSportTVNewsWithQRCode.vue?vue&type=template&id=442864f8&scoped=true"
import script from "./CardTarjaEnqueteSportTVNewsWithQRCode.vue?vue&type=script&lang=js"
export * from "./CardTarjaEnqueteSportTVNewsWithQRCode.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaEnqueteSportTVNewsWithQRCode.vue?vue&type=style&index=0&id=442864f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442864f8",
  null
  
)

export default component.exports